// extracted by mini-css-extract-plugin
module.exports = {"root":"DreamGameCenter_root__lFlpq","main":"DreamGameCenter_main__Hw8NC","more":"DreamGameCenter_more__clrFG"};